<template>
  <div>
    <modal ref="centerModal" sheet-class="ct-sheet ct-lookup">
      <template #header>
        <div class="modal-head">
          <span class="modal-head__icon"><i class="fas fa-city"></i></span>
          <span class="modal-head__text">
            <span class="modal-head__title">{{ state.ui.erp_select_company || 'Select Company' }}</span>
            <span class="modal-head__sub" v-if="state.servicePath">
              <i class="fas fa-plug"></i>
              <span class="cmp-head-path" :title="state.servicePath">{{ state.servicePath }}</span>
            </span>
          </span>
        </div>
      </template>
      <template #body>
        <!-- Company : Search -->
        <div class="cmp-bar">
          <select class="cmp-select" v-model.trim="state.retrieveSearch.field" @change="filterData()">
            <option value="maincode">{{ state.ui.erp_code || 'Code' }}</option>
            <option value="mainname">Company Name (TH)</option>
          </select>
          <div class="cmp-search">
            <i class="fas fa-search"></i>
            <input type="text" :placeholder="state.ui.search || 'ค้นหา'" v-model.trim="state.retrieveSearch.text"
                   @input="filterData()" @keyup.enter="filterData()" />
            <button type="button" class="cmp-search-clear" v-if="state.retrieveSearch.text" @click="clearSearch()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <button type="button" class="cmp-btn" @click="loadData()">
            <i class="fas fa-sync-alt"></i> <span>{{ state.ui.erp_refresh || 'Refresh' }}</span>
          </button>
          <div class="cmp-bar-end">
            <span class="cmp-count">
              <b>{{ state.viewData.length }}</b> {{ state.ui.erp_company || 'Company' }}
            </span>
            <div class="cmp-toggle">
              <button type="button" class="cmp-toggle-btn" :class="{ 'is-on': state.viewMode === 'table' }"
                      @click="state.viewMode = 'table'" title="Table View">
                <i class="fas fa-th-list"></i> <span>{{ state.ui.erp_table || 'Table' }}</span>
              </button>
              <button type="button" class="cmp-toggle-btn" :class="{ 'is-on': state.viewMode === 'card' }"
                      @click="state.viewMode = 'card'" title="Card View">
                <i class="fas fa-th-large"></i> <span>Card</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Company : List -->
        <div class="cmp-grid ag-grid-bordered" v-show="state.viewMode === 'table'">
          <ag-table ref="agr"
                    :footer="false"
                    :sorting="true"
                    @ready="initTable()"
                    @cell-clicked="holdData($event.data, 0)"
                    @double-cell-clicked="sendData($event.data)">
          </ag-table>
        </div>
        <div class="cmp-cards" v-show="state.viewMode === 'card'">
          <div class="cmp-card"
               v-for="x in state.viewData"
               :key="x.maincode"
               :class="{ 'is-on': state.selectedData && state.selectedData.maincode === x.maincode }"
               @click="holdData(x, 0)"
               @dblclick="sendData(x)">
            <span class="cmp-card-mark">{{ String(x.maincode || '?').substring(0, 2).toUpperCase() }}</span>
            <div class="cmp-card-body">
              <div class="cmp-card-code">{{ x.maincode }}</div>
              <div class="cmp-card-name" :title="x.mainname">{{ x.mainname }}</div>
              <div class="cmp-card-meta">
                <span v-if="x.maintel"><i class="fas fa-phone"></i>{{ x.maintel }}</span>
                <span v-if="x.mainadr1" :title="x.mainadr1"><i class="fas fa-map-marker-alt"></i>{{ x.mainadr1 }}</span>
              </div>
            </div>
            <span class="cmp-card-check"><i class="fas fa-check"></i></span>
          </div>
          <div v-if="!state.viewData || state.viewData.length === 0" class="cmp-cards-empty">
            <span class="cmp-cards-empty-icon"><i class="fas fa-inbox"></i></span>
            <span>{{ state.ui.erp_no_data || 'No data' }}</span>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="modal-footer-left">
          <pagination ref="paging" @page-change="pageChange($event.page)"></pagination>
          <button class="btn btn-sm bg-olive" @click="$refs.agr.exportExcel()">
            <i class="fas fa-cloud-download-alt"></i> {{ state.ui.erp_export_excel || 'Export Excel' }}
          </button>
          <button class="btn btn-sm btn-facebook" @click="$refs.agr.printPDF()">
            <i class="fas fa-print"></i> {{ state.ui.erp_print_pdf || 'Print PDF' }}
          </button>
        </div>
        <div class="modal-footer-right">
          <span class="cmp-picked" v-if="state.selectedData && state.selectedData.maincode">
            <i class="fas fa-building"></i> {{ state.selectedData.maincode }} : {{ state.selectedData.mainname }}
          </span>
          <button type="button" class="btn btn-sm bg-olive" :disabled="!state.selectedData || !state.selectedData.maincode"
                  @click="sendData()">
            <i class="fas fa-check-circle"></i> <span v-text="state.ui.select || 'Select'"></span>
          </button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script type="text/javascript">
  import { ref, reactive, computed, onMounted } from '@vue/composition-api'
  let paging = {}
  export default {
    setup(props, { refs, emit }) {

      /* Setup : State */
      var state = reactive({
        baseUrl,
        baseRoute,
        queryString,
        ui,
        retrieveSearch: {},
        respData: [],
        viewData: [],
        displayData: [],
        selectedData: {},
        pageNumber: 1,
        servicePath: null,
        viewMode: 'table',
      })

      /* Setup : Methods */
      let openModal = async (ctx) => {
        refs.centerModal.openModal()

        state.servicePath = ctx?.servicePath || null
        state.retrieveSearch = { text: '', field: 'maincode' }

        state.selectedData = {}

        initTable()

        await loadData()
      }

      let closeModal = () => {
        refs.centerModal.closeModal()
      }

      let loadData = async () => {
        console.log(state.servicePath,"state.servicePath");

        try {
          const formData = {
            form:
            {
                ServicePath: state.servicePath ?? "",
                ServiceEvent: "GetCompanies",
                ServiceName: "LoginCompanies",
            },
          };

          let url = "CSM/Gateway/Dispath";
          let resp = await $xt.postServerJson(url, formData);

          let response = resp?.data || {};

          let detail = response?.data;

          state.respData = detail || []

          /* Display : Reformat Grid */
          initTable()

          /* Display : Header */
          filterData()
        }
        catch (e){
          console.log(e,"e");

        }
      }

      let filterData = () => {
        let text = (state.retrieveSearch.text || '').trim().toLowerCase()
        let field = state.retrieveSearch.field || 'maincode'

        state.viewData = text
          ? $linq(state.respData).where(w => !$xt.isEmpty(w[field]) && w[field].toLowerCase().indexOf(text) > -1).toArray()
          : state.respData

        let agr = refs.agr
        if (agr) agr.setDisplay(state.viewData)
      }

      let clearSearch = () => {
        state.retrieveSearch.text = ''
        filterData()
      }

      let pageChange = (pn) => {
        pn = pn || 1
        state.pageNumber = pn
        paging.setCurrentPage(pn)
        state.displayData = $linq(state.respData).skip(paging.skipItems()).take(paging.getItemsPerPage()).toArray()
        paging.createPagesArray()
      }

      let holdData = (x, idx) => {
        state.selectedData = x
      }

      let sendData = () => {
        emit('send-data', state.selectedData)
        closeModal()
      }

      let initTable = () => {
        let agr = refs.agr

        let fields = [
          ['maincode', ui.erp_code || 'Code', 'text', { width: 120, pinned: 'left' }],
          ['mainname', 'Company Name (TH)', 'text', { width: 400 }],
          ['engname', 'Company Name (EN)', 'text', { width: 400 }],
          ['mainadr1', ui.erp_address1 || 'Address (1)', 'text', { width: 400 }],
          ['mainadr2', ui.erp_address2 || 'Address (2)', 'text', { width: 400 }],
          ['mainpost', ui.erp_post_code || 'Post Code', 'text', { width: 150 }],
          ['maintel', ui.erp_tel || 'Tel.', 'text', { width: 150 }],
          ['mainfax', ui.erp_fax || 'Fax', 'text', { width: 150 }],
          ['maintaxid', 'Tax ID.', 'text', { width: 150 }],
        ]

        let header = agr.createHeaderFromArray(fields)
        agr.setHeader(header)
      }

      /* Setup : Document Ready */
      onMounted(() => {
        paging = refs.paging
        paging.setCurrentPage(1)
        paging.setItemsPerPage(10)

        refs.centerModal.setSize('modal-lg-2')
      })

      return {
        /* Return : State */
        state,
        /* Return : Methods */
        openModal,
        closeModal,
        loadData,
        filterData,
        clearSearch,
        pageChange,
        holdData,
        sendData,
        initTable
      }
    }
  }
</script>

<style scoped>
  .cmp-head-path {
    display: inline-block;
    max-width: 520px;
    font-family: 'Cascadia Mono', 'JetBrains Mono', 'SFMono-Regular', Consolas, Monaco, monospace;
    font-size: 11px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
  }

  .cmp-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 9px;
    padding: 11px 13px;
    margin-bottom: 12px;
    border: 1px solid #eceff5;
    border-radius: 14px;
    background: linear-gradient(180deg, #fbfcfe 0%, #f6f8fc 100%);
    box-shadow: 0 1px 2px rgba(31, 41, 76, 0.04);
  }

  .cmp-bar-end {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  .cmp-select {
    height: 34px;
    min-width: 150px;
    padding: 0 10px;
    border: 1px solid #e5eaf3;
    border-radius: 10px;
    background: #fff;
    font-size: 12.5px;
    color: #55657f;
    outline: none;
    cursor: pointer;
  }

  .cmp-select:focus {
    border-color: #9dc2f0;
    box-shadow: 0 0 0 3px rgba(44, 123, 229, 0.12);
  }

  .cmp-search {
    position: relative;
    display: flex;
    align-items: center;
    flex: 1 1 220px;
    max-width: 320px;
  }

  .cmp-search > i {
    position: absolute;
    left: 12px;
    font-size: 11.5px;
    color: #94a2b8;
    pointer-events: none;
  }

  .cmp-search input {
    width: 100%;
    height: 34px;
    padding: 0 32px;
    border: 1px solid #e5eaf3;
    border-radius: 10px;
    background: #fff;
    font-size: 12.5px;
    color: #16233c;
    outline: none;
    transition: border-color 0.16s, box-shadow 0.16s;
  }

  .cmp-search input::placeholder {
    color: #b3becd;
  }

  .cmp-search input:focus {
    border-color: #9dc2f0;
    box-shadow: 0 0 0 3px rgba(44, 123, 229, 0.12);
  }

  .cmp-search-clear {
    position: absolute;
    right: 6px;
    width: 22px;
    height: 22px;
    border: 0;
    border-radius: 7px;
    background: transparent;
    font-size: 11px;
    color: #94a2b8;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
  }

  .cmp-search-clear:hover {
    background: #eef1f6;
    color: #55657f;
  }

  .cmp-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 34px;
    padding: 0 14px;
    border: 0;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    background: linear-gradient(135deg, #24518c 0%, #17325a 100%);
    box-shadow: 0 6px 14px -8px rgba(23, 50, 90, 0.9);
    cursor: pointer;
    transition: box-shadow 0.16s, transform 0.16s;
  }

  .cmp-btn:hover {
    box-shadow: 0 9px 18px -8px rgba(23, 50, 90, 0.95);
  }

  .cmp-btn:active {
    transform: translateY(1px);
  }

  .cmp-count {
    font-size: 12px;
    color: #7a8799;
    white-space: nowrap;
  }

  .cmp-count b {
    font-size: 13px;
    color: #17325a;
  }

  .cmp-toggle {
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 3px;
    border-radius: 11px;
    background: #e9eef7;
    border: 1px solid #dfe6f2;
  }

  .cmp-toggle-btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    height: 28px;
    padding: 0 12px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    font-size: 11.5px;
    font-weight: 600;
    color: #6b7a90;
    white-space: nowrap;
    cursor: pointer;
    outline: none;
    transition: background 0.18s, color 0.18s, box-shadow 0.18s;
  }

  .cmp-toggle-btn i {
    font-size: 12px;
    opacity: 0.75;
  }

  .cmp-toggle-btn:hover {
    color: #3d4a5c;
    background: rgba(255, 255, 255, 0.6);
  }

  .cmp-toggle-btn.is-on {
    color: #17325a;
    background: #fff;
    box-shadow: 0 2px 7px -2px rgba(23, 50, 90, 0.3);
  }

  .cmp-toggle-btn.is-on i {
    opacity: 1;
    color: #2c7be5;
  }

  .cmp-grid {
    border-radius: 12px;
    overflow: hidden;
  }

  .cmp-cards {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
    gap: 9px;
    max-height: 420px;
    padding: 2px;
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #d0d5dd transparent;
  }

  .cmp-cards::-webkit-scrollbar {
    width: 6px;
  }

  .cmp-cards::-webkit-scrollbar-thumb {
    background: #d6dce6;
    border-radius: 3px;
  }

  .cmp-cards::-webkit-scrollbar-track {
    background: transparent;
  }

  .cmp-card {
    position: relative;
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 12px 14px;
    border: 1px solid #eaeef5;
    border-radius: 13px;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.18s, background 0.18s, box-shadow 0.18s, transform 0.18s;
  }

  .cmp-card:hover {
    border-color: #c3daf5;
    box-shadow: 0 8px 20px -12px rgba(23, 50, 90, 0.55);
    transform: translateY(-1px);
  }

  .cmp-card.is-on {
    border-color: #2c7be5;
    background: #f5faff;
    box-shadow: 0 0 0 1px #2c7be5, 0 8px 20px -12px rgba(44, 123, 229, 0.7);
  }

  .cmp-card-mark {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 38px;
    height: 38px;
    border-radius: 11px;
    font-size: 13px;
    font-weight: 800;
    color: #0b2242;
    background: linear-gradient(135deg, #a9e6ff 0%, #64aeee 100%);
  }

  .cmp-card.is-on .cmp-card-mark {
    color: #fff;
    background: linear-gradient(135deg, #3f9ae8 0%, #17325a 100%);
  }

  .cmp-card-body {
    flex: 1;
    min-width: 0;
  }

  .cmp-card-code {
    font-size: 12.5px;
    font-weight: 700;
    color: #16233c;
    line-height: 1.3;
  }

  .cmp-card-name {
    font-size: 12px;
    color: #55657f;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cmp-card-meta {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 10px;
    margin-top: 3px;
    font-size: 10.5px;
    line-height: 1.3;
    color: #94a2b8;
    overflow: hidden;
  }

  .cmp-card-meta span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cmp-card-meta i {
    margin-right: 4px;
    font-size: 9px;
    opacity: 0.65;
  }

  .cmp-card-check {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 9px;
    color: #fff;
    background: #2c7be5;
    opacity: 0;
    transform: scale(0.6);
    transition: opacity 0.18s, transform 0.18s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  .cmp-card.is-on .cmp-card-check {
    opacity: 1;
    transform: scale(1);
  }

  .cmp-cards-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    grid-column: 1 / -1;
    padding: 46px 20px;
    font-size: 13px;
    color: #9aa7b9;
  }

  .cmp-cards-empty-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 58px;
    height: 58px;
    border-radius: 18px;
    font-size: 21px;
    color: #5c74a0;
    background: linear-gradient(160deg, #f2f6fd 0%, #e3ebf8 100%);
    border: 1px solid #e3eaf6;
  }

  .cmp-picked {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 380px;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 11.5px;
    font-weight: 600;
    color: #17325a;
    background: #eaf2fd;
    border: 1px solid #d5e5fa;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cmp-picked i {
    font-size: 10px;
    opacity: 0.7;
  }

  .modal-footer-left ::v-deep .pagination {
    margin: 0;
  }

  @media (max-width: 767px) {
    .cmp-search {
      max-width: 100%;
    }

    .cmp-bar-end {
      width: 100%;
      margin-left: 0;
      justify-content: space-between;
    }

    .cmp-head-path {
      max-width: 190px;
    }

    .cmp-picked {
      max-width: 150px;
    }
  }
</style>
